function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import CheckRadioBase from './CheckRadioBase';
import PropTypes from 'prop-types';
import "./Checkbox.css";

function Checkbox(props) {
  return /*#__PURE__*/React.createElement(CheckRadioBase, _extends({
    type: "checkbox"
  }, props));
}

Checkbox.propTypes = _extends({
  /** Mark the Checkbox as indeterminate */
  indeterminate: PropTypes.bool
}, CheckRadioBase.propTypes);
Checkbox.defaultProps = _extends({
  indeterminate: false
}, CheckRadioBase.defaultProps);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map